import { connect } from 'react-redux'
import DownloadMPhotosComponent from '../components/DownloadMPhotosComponent.jsx';
import {
	changeDownloadMPhotosValue,
	generateMPhotosFile,
	generateMCasesFile,
	generateMCasesFileNtpc,
	generateDiscardList,
	cleanDownloadMPhotosAlert,
	forwardToFindAllMaintenanceOrderIds,
	forwardToFindMCasesDropDownMenu
} from '../actions';

const mapStateToProps = (state) => ({
	formBean: state.getIn(['downloadMPhotosReducer', 'formBean']),
	formBeanValidation: state.getIn(['downloadMPhotosReducer', 'formBeanValidation']),
	alertStyle: state.getIn(['downloadMPhotosReducer', 'alertStyle']),
	alertMessage: state.getIn(['downloadMPhotosReducer', 'alertMessage']),

	allMOrders: state.getIn(['downloadMPhotosReducer', 'allMOrders']),
	allMCasesByOrder: state.getIn(['downloadMPhotosReducer', 'allMCasesByOrder']),
})

const mapDispatchToProps = (dispatch) => ({
	setValue: (id, value) => {
		dispatch(changeDownloadMPhotosValue({
		  id: id,
		  value: value
		}))
	  },
	generateMPhotosFile: (bean) => {
		dispatch(generateMPhotosFile(bean));
	},
	generateMCasesFile: (bean) => {
		dispatch(generateMCasesFile(bean));
	},
	generateMCasesFileNtpc: (bean, uploadFileNtpc) => {
		dispatch(generateMCasesFileNtpc(bean, uploadFileNtpc));
	},
	generateDiscardList: (bean) => {
		dispatch(generateDiscardList(bean));
	},
	cleanAlert: () => {
		dispatch(cleanDownloadMPhotosAlert());
	},
	findAllOrderIds: () => {
		dispatch(forwardToFindAllMaintenanceOrderIds());
	},
	findMCasesDropDownMenu: (orderId) => {
		dispatch(forwardToFindMCasesDropDownMenu(orderId));
	},
})

const DownloadMPhotosContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(DownloadMPhotosComponent)

export default DownloadMPhotosContainer;


// WEBPACK FOOTER //
// ./src/containers/DownloadMPhotosContainer.jsx